import $ks from "../lib/ks";
import setNumOnlyInput from '../lib/setNumOnlyInput';
import DrawTextInnerShadow from '../lib/textInnerShadow';

class Timer {
    constructor(common, timerParams) {
        this.common = common;

        this.focusedInputIdx = 2;

        this.chosenType = 'clock';

        this.startAni = timerParams.startAni;
    }

    // initialization methods (최초 1회 실행)
    init() {
        this.reset();
        this.inputs.forEach((input, idx) => {
            $ks.addFocusEvents(input);
            setNumOnlyInput(input, 2);
            input.addEventListener('mousedown', () => {
                this.focusingInput(idx);
            }, false);
            input.addEventListener('touchstart', () => {
                this.focusingInput(idx);
            }, false);
        });

        this.drawTypeChoiceBoxTitle();
        this.setTypeChoiceBtns();
        this.drawNumBtns();
        this.setStartBtn();
        this.setClearBtn();
    }

    drawTypeChoiceBoxTitle() {
        let title = $ks.ce({
            tag: 'div',
            targetElement: $ks.getByClass('timer_typeChoiceBox_title', document, 0)
        })
        new DrawTextInnerShadow(title, {
            width: 208,
            height: 71,
            rgbColor: '#666666',
            font: '35px NanumSquareEB',
            text: '타이머 선택',
            textPosition: {x: 17, y: 45},
            shadowDarkenPercent: -80,
            shadowWidth: 1,
            shadowPosition: {x: 0, y: 1}
        }).draw();
    }

    setTypeChoiceBtns() {
        this.typeChoiceBtns.forEach((btn) => {
            $ks.addDownEvents(btn);
            $ks.addHoverEvents(btn);
            btn.addEventListener('click', (e) => {
                this.focusingTypeChoiceBtn(e.target.classList[0]);
            }, false);
        });
    }

    drawNumBtns() {
        let numBtns, li, div;
        numBtns = $ks.getById('timer_numBtns');
        for (let i = 0; i < 10; i++) {
            li = $ks.ce({
                tag: 'li',
                class: 'timer_numBtn',
                targetElement: numBtns
            });
            li.num = i;

            this.drawNum(li, i);

            $ks.addDownEvents(li, {preventDefault: true});
            $ks.addHoverEvents(li);

            li.addEventListener('click', (e) => {
                e.preventDefault();
                this.numBtnClickEv(e);
            }, false);
            li.addEventListener('touchend', (e) => {
                e.preventDefault();
                this.numBtnClickEv(e);
            }, false);
        }
    }

    drawNum(element, idx) {
        let text = idx.toString();
        new DrawTextInnerShadow(element, {
            width: 74,
            height: 74,
            rgbColor: '#666666',
            font: '40px NanumSquareEB',
            text: text,
            textPosition: {x: 25, y: 50},
            shadowDarkenPercent: -80,
            shadowWidth: 1,
            shadowPosition: {x: 0, y: 1}
        }).draw();
    }

    setStartBtn() {
        let btn = $ks.getById('timer_startBtn');
        $ks.addDownEvents(btn);
        $ks.addHoverEvents(btn);
        btn.addEventListener('click', (e) => {
            this.startBtnClickEv(e);
        }, false);

        return this.drawStartBtn(btn);
    }

    drawStartBtn(btn) {
        new DrawTextInnerShadow(btn, {
            width: 192,
            height: 192,
            rgbColor: '#219dc7',
            font: '50px NanumSquareEB',
            text: 'Start',
            textPosition: {x: 30, y: 90},
            shadowDarkenPercent: -80,
            shadowWidth: 1,
            shadowPosition: {x: 0, y: 1}
        }).draw();
    }

    setClearBtn() {
        let btn = $ks.getById('timer_clearBtn');
        $ks.addDownEvents(btn);
        $ks.addHoverEvents(btn);
        btn.addEventListener('click', () => {
            this.resetInputs();
        }, false);

        return this.drawClearBtn(btn);
    }

    drawClearBtn(btn) {
        new DrawTextInnerShadow(btn, {
            width: 192,
            height: 192,
            rgbColor: '#cc3333',
            font: '50px NanumSquareEB',
            text: 'Clear',
            textPosition: {x: 30, y: 95},
            shadowDarkenPercent: -80,
            shadowWidth: 1,
            shadowPosition: {x: 0, y: 1}
        }).draw();
    }

    // 동작 관련 methods (계속 실행)
    focusingTypeChoiceBtn(type) {
        if (type) this.chosenType = type;
        this.typeChoiceBtns.forEach((btn) => {
            if ($ks.hasClass(btn, this.chosenType))
                $ks.addClass(btn, 'on');
            else
                $ks.removeClass(btn, 'on');
        });
    }

    focusingInput(idx) {
        if (idx || idx === 0) this.focusedInputIdx = idx;
        this.inputs.forEach((input, idx) => {
            if (idx === this.focusedInputIdx) {
                input.focus();
                $ks.addClass(input, 'focused');
            }
        });
    }

    numBtnClickEv(e) {
        let element, elementIsNotNumBtn, targetInput;
        element = e.target;
        if (!element.classList || !element.classList.contains('timer_numBtn')) {
            while (!element.classList || !element.classList.contains('timer_numBtn')) {
                element = element.parentNode;
            }
        }
        targetInput = this.inputs[this.focusedInputIdx];

        if (targetInput.value.length === 2)
            targetInput.value = targetInput.value.slice(1, 2);

        this.inputs[this.focusedInputIdx].value+= element.num;

        this.focusingInput();
    }

    startBtnClickEv(e) {
        if (this.time)
            this.startAni(this.type, this.time);
        else
            this.focusingInput();
    }

    // 초기화 관련 methods
    reset() {
        this.common.bgSwitcher('timer');
        this.common.turnOnClass(this.common.mains, 'timer', 'on');
        this.common.turnOnClass(this.common.tabs, 'stopWatch', 'on');
        this.resetInputs();
        this.resetTypeChoiceBtns();
    }

    resetTypeChoiceBtns() {
        this.focusingTypeChoiceBtn('clock');
    }

    resetInputs() {
        this.inputs.forEach((input) => {
            input.value = "00";
            this.focusingInput();
        });
    }

    //////////////
    // gettters //
    //////////////

    // inputs 가져오기
    get inputs() { return $ks.getByClass('timerInput'); }

    // 타이머 선택 버튼들 가져오기
    get typeChoiceBtns() { return $ks.getByTag('li', $ks.getById('timer_typeChoiceBtns')); }

    // 시간 get
    get time() {
        let returnValue = 0;
        this.inputs.forEach((input, idx) => {
           if (input.value !== "00" && input.value.length !== 0) {
               if (idx === 0) returnValue += Number.parseInt(input.value) ? Number.parseInt(input.value) * 60 * 60 * 100 : 0;
               else if (idx === 1) returnValue += Number.parseInt(input.value) ? Number.parseInt(input.value) * 60 * 100 : 0;
               else returnValue += Number.parseInt(input.value) ? Number.parseInt(input.value) * 100 : 0;
           }
        });

        return returnValue;
    }

    // 타이머 종류 get
    get type() {
        let type = '';
        this.typeChoiceBtns.forEach((btn) => {
            if ($ks.hasClass(btn, 'on'))
                type = btn.classList[0];
        });
        return type;
    }
}

export default Timer;
